import React, { useState } from 'react';
import { useGSAP } from "@gsap/react";
import gsap from 'gsap'
import { ScrollTrigger } from 'gsap/all';
import SplitType from 'split-type'
import Lenis from 'lenis'

import 'lenis/dist/lenis.css'
import Container from 'react-bootstrap/Container';
import Slider from "react-slick";
import Col from 'react-bootstrap/Col';
// import NavDropdown from 'react-bootstrap/NavDropdown';
import Carousel from 'react-bootstrap/Carousel';

// CSS
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
// Images
import clients_01 from '../assets/clients/clients-01.png'
import clients_02 from '../assets/clients/clients-02.png'
import clients_03 from '../assets/clients/clients-03.png'
import clients_04 from '../assets/clients/clients-04.png'

import scrollDown from '../assets/scroll-down.svg'
import banner_01 from '../assets/Banner01.webp'
import banner_02 from '../assets/Banner02.webp'
import banner_03 from '../assets/Banner03.webp'
import banner_04 from '../assets/Banner04.webp'
import banner_05 from '../assets/Banner05.webp'

import icon_01 from '../assets/icons/badge.png'
import icon_02 from '../assets/icons/beers.png'
import icon_03 from '../assets/icons/signboard.png'
import icon_04 from '../assets/icons/customer-support.png'
import icon_05 from '../assets/icons/beer.png'
import icon_06 from '../assets/icons/partnership.png'
import filterbanner01 from '../assets/filter-banner01.webp'
import filterbanner02 from '../assets/filter-banner02.webp'
import filterbanner03 from '../assets/filter-banner03.webp'
import Logo_black from '../assets/Logos/Brewing-solutions-3.png'
import glass_01 from '../assets/Glass/plane.png'
import glass_02 from '../assets/Glass/light.png'
import glass_03 from '../assets/Glass/darker.png'
import glass_04 from '../assets/Glass/dark.png'
import glass_05 from '../assets/Glass/pitchdark.png'

import experience_01 from '../assets/Experience/company_01.webp'
import experience_02 from '../assets/Experience/company_02.webp'
import experience_03 from '../assets/Experience/company_03.webp'
import experience_04 from '../assets/Experience/company_04.webp'
import experience_05 from '../assets/Experience/company_05.webp'
import experience_06 from '../assets/Experience/company_06.webp'
import experience_07 from '../assets/Experience/company_07.webp'
// Videos
import pintsbgvideos from '../assets/pintswebvideos.webm'
// import { Pagination } from 'react-bootstrap';

import Footer from './footer';
import Header from './header';
import Contactform from './contact-form'


gsap.registerPlugin(ScrollTrigger) 

function Home() {



    let settings = {
        dots: false,
        lazyLoad: true,
        infinite: true,
        speed: 2000,
        slidesToShow: 3,
   
        // arrows: false,
        responsive: [{
 
            breakpoint: 1024,
            settings: {
              slidesToShow: 3,
              slidesToScroll: 3,
            }
       
          }, {
       
            breakpoint: 600,
            settings: {
              slidesToShow: 2,
              slidesToScroll: 2,
            }
       
          }],
        autoplay: true,
        autoplaySpeed: 1000,
        cssEase: "linear"
      };

      let product_item = {
        dots: false,
        lazyLoad: true,
        infinite: true,
        speed: 3000,
        arrows: false,
        slidesToShow: 3,
        responsive: [{
 
            breakpoint: 1024,
            settings: {
              slidesToShow: 3,
            }
       
          }, {
       
            breakpoint: 600,
            settings: {
              slidesToShow: 2,
            }
       
          }],
        slidesToScroll: 1,
        autoplay: true,
        autoplaySpeed: 3000,
        cssEase: "linear"
      };


      let experience = {
        dots: false,
        lazyLoad: true,
        infinite: true,
        speed: 3000,
        arrows: false,
        slidesToShow: 3,
        responsive: [{
 
            breakpoint: 1024,
            settings: {
              slidesToShow: 3,
              slidesToScroll: 3
            }
       
          }, {
       
            breakpoint: 600,
            settings: {
              slidesToShow: 3,
              slidesToScroll: 3
            }
       
          }],
        // slidesToScroll: 1,
        autoplay: true,
        autoplaySpeed: 1000,
        cssEase: "linear"
      };
    
    const [interval] = useState(3000);
    
    const lenis = new Lenis({
        duration: 2.2,
        easing: (t) => Math.min(1, 1.001 - Math.pow(2, -10 * t)), 
        direction: 'vertical', // vertical, horizontal
        gestureDirection: 'vertical', // vertical, horizontal, both
        smooth: true,
        mouseMultiplier: 1,
        smoothTouch: true,
        touchMultiplier: 2,
        infinite: false,
      })

//get scroll value
lenis.on('scroll', ({ scroll, limit, velocity, direction, progress }) => {
console.log({ scroll, limit, velocity, direction, progress })
})

function raf(time) {
lenis.raf(time)
requestAnimationFrame(raf)
}

requestAnimationFrame(raf)

    useGSAP(() => {



let h1 = new SplitType('.left-grid-details h1', {
  types: 'words',
  tagName: 'span'
})

let p = new SplitType('.left-grid-details p', {
    types: ' words',
    tagName: 'span'
  })


  
const mainheader = new SplitType('._h1lines',{   types: 'words',tagName: 'span'})

let _plines = new SplitType('._plines', {
    types: 'words',
    tagName: 'span'
  })
  
let tl = gsap.timeline({
    scrollTrigger: {
        trigger:".section-scroll-text-animation",
        // pin: true,
        start: "top 30%",
        end: "top bottom",
        scrub: 8,
        toggleActions: "restart none none none",
        // markers:true
    }
    });


    tl.from(mainheader.words, {
        opacity: 0,
        x: -100,
        duration: 2,
        delay:2,
        ease: 'ease.sine',
  stagger: .8,
    });

    tl.from( _plines.words, {
        opacity: 0,
        x: -200,
        duration: 1,
        stagger: 0.2,
        // delay: 1,
        ease: 'ease.sine',
    });

      gsap.from( h1.words, {
        y: '100%',
        opacity: 0,
        duration: .5,
        stagger: 0.09,
        ease: 'power1.out',
      })
      
      gsap.from(p.words, {
        y: '100%',
        opacity: 0,
        duration: .5,
        stagger: 0.09,
        ease: 'power1.out',
        })
      


    let fadein = gsap.utils.toArray('.section-scroll-anime')
    fadein.forEach((item, index) => {
    
    let tl = gsap.timeline({
      scrollTrigger: {
      trigger: item,
    //   pin: true,
    start: "top 30%",
    end: "top bottom",
    scrub: 8,
      toggleActions:"restart none none reset",
      }
    });
    tl.from(item, {
        opacity: 0,
        x: -200,
        duration: 1,
        stagger: 0.2,
        // delay: 0.6,
        ease: 'ease.sine'
      });
    });

 







//   sticky-about-banner-2

// const stickyh1 = new SplitType('.h2.text-align-left',{   types: 'chars',tagName: 'span'})
// const stickyplines = new SplitType('._plines',{ types: 'lines' })
//  gsap.timeline({
   
//     scrollTrigger: {
//         paused: true,
//         trigger:".review__title-2.review_intro",
//         start: "top bottom",
//         end: "bottom bottom",
//         scrub: 1,
//         toggleActions: "restart none none none"
//     }
//     });

    // st.from(stickyh1.chars, { opacity: 0, scale:0.5, yPercent: 100, duration: 0.3, ease: "back.out(2)", stagger: 0.3 });


    let tn = gsap.timeline({
        // autoAlpha: 0,
        scrollTrigger: {
            trigger: '.section-home-scroll',
            start: "top bottom",
            end: "top center",
            scrub: 3,
            // pin: true,
            // pinSpacing: false,
            toggleActions: "reverse none play none"
        }
      });
      tn.from('.section-home-scroll', {
        y:200,
        opacity: .3,
        duration: 1,
        // scale: .9,
        stagger: 1,
        animation: tn,
        ease: "sine.in",
      });

    })
    return (
        <section className='paint-container home-page' id="smooth-wrapper">
              {/* ////////////Navbar */}
              <Header/>

            <div className="page-wrapper" id="smooth-content">
    <div className="sticky-wrapper">
        <Container className="section-home-hero" fluid>
            <div className="padding-custom is--home--hero">
                <div className="hero-bg-wrapper is--home">
                    <div className="content-container">
                           <Col className='left-grid'>
                                <div className='left-grid-details'>
                                <img src={Logo_black} alt='Logo_black' className=''/>
                                  <h1 className='_h1'>
                                  Brew Your Own Craft Beer</h1>
                                  <p className='Roboto-Thin'>
                                  We brew & manage your brewery, you reap the rewards
                                    </p>
                                  <a href="#collection-2" className='scroll-down'>
                                  <img src={scrollDown} alt='scrollDown' width="100" height="auto"/>
                                  </a>
                                </div>
                              
                            </Col>
                    </div>

                    <div className="content-container is--home--hero home_carousel">
                    <Carousel data-bs-theme="dark" interval={interval} slide={true} fade={true}>
                        <Carousel.Item>
                        <img
                        className="d-block w-100"
                        src={banner_01}
                        alt="First slide"
                        />
                        {/* <Carousel.Caption>
                        <h5>In-depth Audit</h5>
                        <p>We thoroughly assess your brewery's equipment & operations</p>
                        </Carousel.Caption> */}
                        </Carousel.Item>
                        <Carousel.Item>
                        <img
                        className="d-block w-100"
                        src={banner_02}
                        alt="Second slide"
                        />
                        {/* <Carousel.Caption>
                        <h5>Challenge Resolution</h5>
                        <p>We collaborate with vendors to address any issues & provide expert guidance</p>
                        </Carousel.Caption> */}
                        </Carousel.Item>
                        <Carousel.Item>
                        <img
                        className="d-block w-100"
                        src={banner_03}
                        alt="Third slide"
                        />
                        {/* <Carousel.Caption>
                        <h5>Brewing Excellence</h5>
                        <p>
                        Our experienced team takes over brewing operations, focusing on quality & effciency
                        </p>
                        </Carousel.Caption> */}
                        </Carousel.Item>
                       
                        <Carousel.Item>
                        <img
                        className="d-block w-100"
                        src={banner_04}
                        alt="Fourth slide"
                        />
                        {/* <Carousel.Caption>
                        <h5>Brewing Excellence</h5>
                        <p>
                        Our experienced team takes over brewing operations, focusing on quality & effciency
                        </p>
                        </Carousel.Caption> */}
                        </Carousel.Item>

                        <Carousel.Item>
                        <img
                        className="d-block w-100"
                        src={banner_05}
                        alt="Fourth slide"
                        />
                        {/* <Carousel.Caption>
                        <h5>Brewing Excellence</h5>
                        <p>
                        Our experienced team takes over brewing operations, focusing on quality & effciency
                        </p>
                        </Carousel.Caption> */}
                        </Carousel.Item>
                        </Carousel>
                        <div className="footer-social-icon">
                                <a href="https://www.facebook.com/people/Pints-Brewing-Solutions/61563104886183/" target="_blank">
                                    <svg xmlns="http://www.w3.org/2000/svg" width="25" height="25" fill="currentColor" className="bi bi-facebook" viewBox="0 0 16 16">
                                      <path d="M16 8.049c0-4.446-3.582-8.05-8-8.05C3.58 0-.002 3.603-.002 8.05c0 4.017 2.926 7.347 6.75 7.951v-5.625h-2.03V8.05H6.75V6.275c0-2.017 1.195-3.131 3.022-3.131.876 0 1.791.157 1.791.157v1.98h-1.009c-.993 0-1.303.621-1.303 1.258v1.51h2.218l-.354 2.326H9.25V16c3.824-.604 6.75-3.934 6.75-7.951"/>
                                    </svg>
                                </a>
                                <a href="https://x.com/PintsBeer"  target="_blank">
                                <svg xmlns="http://www.w3.org/2000/svg" width="25" height="25" className="bi bi-twitter" viewBox="0 0 32 32" version="1.1">
                                        <g id="surface1"><rect x="0" y="0" width="32" height="32"/> <path d="M 12.003906 6.125 L 5.1875 6.125 L 13.265625 16.796875 L 5.703125 25.75 L 9.199219 25.75 L 14.917969 18.980469 L 19.996094 25.6875 L 26.8125 25.6875 L 18.496094 14.707031 L 18.511719 14.722656 L 25.671875 6.25 L 22.175781 6.25 L 16.859375 12.542969 Z M 8.949219 7.992188 L 11.070312 7.992188 L 23.050781 23.820312 L 20.929688 23.820312 Z M 8.949219 7.992188 "/></g>
                                </svg>
                                </a>
                                <a href="https://www.instagram.com/pints.beer/"  target="_blank">
                                    <svg xmlns="http://www.w3.org/2000/svg" width="25" height="25" fill="currentColor" className="bi bi-instagram" viewBox="0 0 16 16">
                                      <path d="M8 0C5.829 0 5.556.01 4.703.048 3.85.088 3.269.222 2.76.42a3.9 3.9 0 0 0-1.417.923A3.9 3.9 0 0 0 .42 2.76C.222 3.268.087 3.85.048 4.7.01 5.555 0 5.827 0 8.001c0 2.172.01 2.444.048 3.297.04.852.174 1.433.372 1.942.205.526.478.972.923 1.417.444.445.89.719 1.416.923.51.198 1.09.333 1.942.372C5.555 15.99 5.827 16 8 16s2.444-.01 3.298-.048c.851-.04 1.434-.174 1.943-.372a3.9 3.9 0 0 0 1.416-.923c.445-.445.718-.891.923-1.417.197-.509.332-1.09.372-1.942C15.99 10.445 16 10.173 16 8s-.01-2.445-.048-3.299c-.04-.851-.175-1.433-.372-1.941a3.9 3.9 0 0 0-.923-1.417A3.9 3.9 0 0 0 13.24.42c-.51-.198-1.092-.333-1.943-.372C10.443.01 10.172 0 7.998 0zm-.717 1.442h.718c2.136 0 2.389.007 3.232.046.78.035 1.204.166 1.486.275.373.145.64.319.92.599s.453.546.598.92c.11.281.24.705.275 1.485.039.843.047 1.096.047 3.231s-.008 2.389-.047 3.232c-.035.78-.166 1.203-.275 1.485a2.5 2.5 0 0 1-.599.919c-.28.28-.546.453-.92.598-.28.11-.704.24-1.485.276-.843.038-1.096.047-3.232.047s-2.39-.009-3.233-.047c-.78-.036-1.203-.166-1.485-.276a2.5 2.5 0 0 1-.92-.598 2.5 2.5 0 0 1-.6-.92c-.109-.281-.24-.705-.275-1.485-.038-.843-.046-1.096-.046-3.233s.008-2.388.046-3.231c.036-.78.166-1.204.276-1.486.145-.373.319-.64.599-.92s.546-.453.92-.598c.282-.11.705-.24 1.485-.276.738-.034 1.024-.044 2.515-.045zm4.988 1.328a.96.96 0 1 0 0 1.92.96.96 0 0 0 0-1.92m-4.27 1.122a4.109 4.109 0 1 0 0 8.217 4.109 4.109 0 0 0 0-8.217m0 1.441a2.667 2.667 0 1 1 0 5.334 2.667 2.667 0 0 1 0-5.334"/>
                                    </svg>
                                </a>

                                <a href="https://www.linkedin.com/in/pints-beer-78a405356/"  target="_blank">
                                    <svg xmlns="http://www.w3.org/2000/svg" width="25" height="25" fill="currentColor" className="bi bi-linkedin" viewBox="0 0 16 16">
                                      <path d="M0 1.146C0 .513.526 0 1.175 0h13.65C15.474 0 16 .513 16 1.146v13.708c0 .633-.526 1.146-1.175 1.146H1.175C.526 16 0 15.487 0 14.854zm4.943 12.248V6.169H2.542v7.225zm-1.2-8.212c.837 0 1.358-.554 1.358-1.248-.015-.709-.52-1.248-1.342-1.248S2.4 3.226 2.4 3.934c0 .694.521 1.248 1.327 1.248zm4.908 8.212V9.359c0-.216.016-.432.08-.586.173-.431.568-.878 1.232-.878.869 0 1.216.662 1.216 1.634v3.865h2.401V9.25c0-2.22-1.184-3.252-2.764-3.252-1.274 0-1.845.7-2.165 1.193v.025h-.016l.016-.025V6.169h-2.4c.03.678 0 7.225 0 7.225z"/>
                                    </svg>
                                </a>
                            </div>
                    </div>
                </div>
            </div>
        </Container>

      

        <div className="section-home-intro section-scroll-text-animation"  id='collection-2'>
            <div id="homeintro" className="padding-custom is--home--intro">
                {/* <img src="https://cdn.prod.website-files.com/63f9558eecdaabcd7d449b81/63f9558eecdaab03ad449cd5_5fb3d97764b65dcb4202e05b_p1-flourish-1%20(1).png" alt="" className="grapic_img"/> */}
                <div className="home-intro-img-wrapper is--2">
                    {/* <div className="bg-cream is-2"></div> */}
                    <Carousel data-bs-theme="dark">
                        <Carousel.Item>
                        <img
                        className="d-block w-100"
                        src={filterbanner01}
                        alt="First slide"
                        />
                        
                        </Carousel.Item>
                        <Carousel.Item>
                        <img
                        className="d-block w-100"
                        src={filterbanner02}
                        alt="Second slide"
                        />
                        
                        </Carousel.Item>
                        <Carousel.Item>
                        <img
                        className="d-block w-100"
                        src={filterbanner03}
                        alt="Third slide"
                        />
                        </Carousel.Item>
                 </Carousel>
                                
                </div>
                <div className="home-intro-img-wrapper is--1">
                </div>
                <div className="home-intro-container">
                    <div id="Home-Intro" className="content-container is--home--intro is--1">
                        <h2 className="h1 black _h1lines">
                        Awesome Brewers & Award winning Recipes Benefitting Your Brand
                        </h2>
                        <div className="inner-content-wrapper is--home--intro">
                            <ul>
                               <li className="p-text _plines">
                               • Skilled brewing team, who poses master’s in microbiology, brewing, distilling, mechanical engineering, chemical engineering, commercial packaging, etc. respectively
                                </li>
                               <li className="p-text _plines">
                               • Recipes designed by brewmasters, who have over a decade of experience in outstanding brands like Toit, Byg Brewsky, etc.
                                </li>
                               <li className="p-text _plines">
                               • Managing a brewery inside a fast paced FnB outlet can be challenging, we eliminate that from your operations and handle it with ease and precision.
                                </li>
                            </ul>
                         
                            <a href="/about-pints" className="link-block w-inline-block">
                                <div className="inner-btn">
                                    <div className="text-block">About</div>
                                    <div className="right-arrow-wrapper is--relative">
                                        <div className="right-arrow-svg w-embed"><svg
                                                 width="inherit"
                                                height="inherit" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"
                                                fill="none">
                                                <path fill-rule="evenodd" clip-rule="evenodd"
                                                    d="M12.6068 4.2343C12.2163 3.84378 11.5831 3.84378 11.1926 4.2343C10.8021 4.62482 10.8021 5.25799 11.1926 5.64851L14.5443 9.00022H4.16797C3.61568 9.00022 3.16797 9.44794 3.16797 10.0002C3.16797 10.5525 3.61568 11.0002 4.16797 11.0002H14.5451L11.1926 14.3527C10.8021 14.7433 10.8021 15.3764 11.1926 15.767C11.5831 16.1575 12.2163 16.1575 12.6068 15.767L17.666 10.7077C18.0566 10.3172 18.0566 9.68405 17.666 9.29352L12.6068 4.2343Z"
                                                    fill="#000" fill-opacity="0.88"></path>
                                            </svg></div>
                                    </div>
                                </div>
                            </a>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    
    <div className="section-home-products is--clients">
        <div className="products__flavors__text__wrapper">
            <h3 className="section-heading">
                Our Satisfied<br/>
                <b>clients</b>
            </h3>
          <div>
          <a href="/Pints-clients" className="link-block w-inline-block">
                                <div className="inner-btn">
                                    <div className="text-block">Clients</div>
                                    <div className="right-arrow-wrapper is--relative">
                                        <div className="right-arrow-svg w-embed"><svg
                                                 width="inherit"
                                                height="inherit" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"
                                                fill="none">
                                                <path fill-rule="evenodd" clip-rule="evenodd"
                                                    d="M12.6068 4.2343C12.2163 3.84378 11.5831 3.84378 11.1926 4.2343C10.8021 4.62482 10.8021 5.25799 11.1926 5.64851L14.5443 9.00022H4.16797C3.61568 9.00022 3.16797 9.44794 3.16797 10.0002C3.16797 10.5525 3.61568 11.0002 4.16797 11.0002H14.5451L11.1926 14.3527C10.8021 14.7433 10.8021 15.3764 11.1926 15.767C11.5831 16.1575 12.2163 16.1575 12.6068 15.767L17.666 10.7077C18.0566 10.3172 18.0566 9.68405 17.666 9.29352L12.6068 4.2343Z"
                                                    fill="#000" fill-opacity="0.88"></path>
                                            </svg></div>
                                    </div>
                                </div>
                            </a>
          </div>
        </div>
        {/* Client Logo */}
        <div className='slider-container'>
          <div className='brand-mt20'>
          <Slider {...settings}>
            <div> 
                <img className="d-block-w-100" src={clients_03} alt="First slide"/>
                 <b className='fs-6 text-white my-2 d-inline-block w-100'>Chin Lung Brewery</b>
                 <p className='text-white'>A Legacy pub in the Bangalore FnB space curating the best of Banga...</p>
            </div>
            <div>
                <img className="d-block-w-100" src={clients_02} alt="Second slide"/>
                <b className='fs-6 text-white my-2 d-inline-block w-100'>Brau Galie</b>
                <p className='text-white'>India’s first glass brewhouse has landed in Bangalore. Super experiential brewhouse...</p>
           </div>
            <div>
                <img className="d-block-w-100" src={clients_01} alt="Second slide"/>
            <b className='fs-6 text-white my-2 d-inline-block w-100'>Druid Garden</b>
            <p className='text-white'>India’s first Czech microbrewery with the largest lagering capacity in India. Capab...</p>
            </div>
            <div><img className="d-block-w-100" src={clients_04} alt="Second slide"/>
            <b className='fs-6 text-white my-2 d-inline-block w-100'>Old Mill Brewery</b>
            <p className='text-white'>A hyperlocal microbrewery coming in hot with fresh and local craft beers...</p>
            </div>
            
         </Slider>
          </div>

          {/* <div className='is--mobile mt-5'>

            <div className='col-4 my-3 x-small d-inline-block'> 
                <div className='clients-list'><img className="d-block-w-100" src={clients_03} alt="First slide"/></div>
                 <b className='fs-6 text-white my-2 d-inline-block w-100'>Chin Lung Brewery</b>
                 <p className='text-white'>A Legacy pub in the Bangalore FnB space curating the best of Banga...</p>
            </div>
            <div className='col-4 my-3 x-small d-inline-block'>
            <div className='clients-list'><img className="d-block-w-100" src={clients_02} alt="Second slide"/></div>
                <b className='fs-6 text-white my-2 d-inline-block w-100'>Brau Galie</b>
                <p className='text-white'>India’s first glass brewhouse has landed in Bangalore. Super experiential brewhouse...</p>
           </div>
            <div className='col-4 my-3 x-small d-inline-block'>
            <div className='clients-list'><img className="d-block-w-100" src={clients_01} alt="Second slide"/></div>
            <b className='fs-6 text-white my-2 d-inline-block w-100'>Druid Garden</b>
            <p className='text-white'>India’s first Czech microbrewery with the largest lagering capacity in India. Capab...</p>
            </div>
            <div className='col-4 my-3 x-small d-inline-block'>
            <div className='clients-list'><img className="d-block-w-100" src={clients_04} alt="Second slide"/></div>
            <b className='fs-6 text-white my-2 d-inline-block w-100'>Old Mill Brewery</b>
            <p className='text-white'>A hyperlocal microbrewery coming in hot with fresh and local craft beers...</p>
            </div>
          </div> */}
        </div>
    </div>

    <div className="section-home-products is--products">
        <div className="products">
            <div className='product-carousel py-4'>
            {/* product_item */}
              <Slider {...product_item}>
                  <div className='slider-product'>
                        <div className='product-carousel-item'>
                            <div className='product-carousel-brand'>
                                <img src={glass_01} alt='glass' className='glass-responsive'/>
                            </div>
                            <div className='product-carousel-details'>
                                <h4 className='fw-bold text-black'>Czech Pilsner </h4>
                                <p className='text-black'>A refreshing pale Czech lager with considerable malt and hop character and a long finish. The malt flavors are complex for...</p>
                            </div>
                        </div>
                  </div>
                  <div className='slider-product'>
                        <div className='product-carousel-item'>
                            <div className='product-carousel-brand'>
                                <img src={glass_02} alt='glass' className='glass-responsive'/>
                            </div>
                            <div className='product-carousel-details'>
                                <h4 className='fw-bold text-black'>Vienna Lager</h4>
                                <p className='text-black'>A moderate-strength amber lager with a soft, smooth maltiness and moderate bitterness...</p>
                            </div>
                        </div>
                  </div>
                  <div className='slider-product'>
                        <div className='product-carousel-item'>
                            <div className='product-carousel-brand'>
                            <img src={glass_01} alt='glass' className='glass-responsive'/>
                            </div>
                            <div className='product-carousel-details'>
                                <h4 className='fw-bold text-black'>Hefeweizen</h4>
                                <p className='text-black'>An authentic Bavarian style refreshing, lightly-hopped wheat beer with high carbonation...</p>
                            </div>
                        </div>
                  </div>

                  {/* <div className='slider-product'>
                        <div className='product-carousel-item'>
                            <div className='product-carousel-brand'>
                                <img src={glass_02} alt='glass' className='glass-responsive'/>
                            </div>
                            <div className='product-carousel-details'>
                                <h4 className='fw-bold text-black'>Dark Lager </h4>
                                <p className='text-black'>A lager which is dark, rich body and flavor, but equally restrained in bitterness. The low...</p>
                            </div>
                        </div>
                  </div> */}

                  <div className='slider-product'>
                        <div className='product-carousel-item'>
                            <div className='product-carousel-brand'>
                                <img src={glass_01} alt='glass' className='glass-responsive'/>
                            </div>
                            <div className='product-carousel-details'>
                                <h4 className='fw-bold text-black'>Witbier</h4>
                                <p className='text-black'>A pale, hazy Belgian wheat beer with spices like bitter orange zest and coriander pods...</p>
                            </div>
                        </div>
                  </div>

                  <div className='slider-product'>
                        <div className='product-carousel-item'>
                            <div className='product-carousel-brand'>
                            <img src={glass_02} alt='glass' className='glass-responsive'/>
                            </div>
                            <div className='product-carousel-details'>
                                <h4 className='fw-bold text-black'>Blonde</h4>
                                <p className='text-black'>We have brewed several versions of blonde and won an award amongst the Indian brewers community... </p>
                            </div>
                        </div>
                  </div>

                  <div className='slider-product'>
                        <div className='product-carousel-item'>
                            <div className='product-carousel-brand'>
                            <img src={glass_01} alt='glass' className='glass-responsive'/>
                            </div>
                            <div className='product-carousel-details'>
                                <h4 className='fw-bold text-black'>IPA</h4>
                                <p className='text-black'>We have brewed several variations in IPA. Several accolades have been shared from the brewing... </p>
                            </div>
                        </div>
                  </div>

                  <div className='slider-product'>
                        <div className='product-carousel-item'>
                            <div className='product-carousel-brand'>
                            <img src={glass_03} alt='glass' className='glass-responsive'/>
                            </div>
                            <div className='product-carousel-details'>
                                <h4 className='fw-bold text-black'>Weizenbock</h4>
                                <p className='text-black'>A strong and malty German wheat beer combining the best wheat and yeast flavors of a Weissbier with the rich malt... </p>
                            </div>
                        </div>
                  </div>
                  
                  <div className='slider-product'>
                        <div className='product-carousel-item'>
                            <div className='product-carousel-brand'>
                            <img src={glass_04} alt='glass' className='glass-responsive'/>
                            </div>
                            <div className='product-carousel-details'>
                                <h4 className='fw-bold text-black'>Raspberry Gose</h4>
                                <p className='text-black'>A sour, salty, juicy beer which was mostly brewed in Goslar, Lower Saxony, Germany using the water from the salty... </p>
                            </div>
                        </div>
                  </div>
                  <div className='slider-product'>
                        <div className='product-carousel-item'>
                            <div className='product-carousel-brand'>
                                <img src={glass_03} alt='glass' className='glass-responsive'/>
                            </div>
                            <div className='product-carousel-details'>
                                <h4 className='fw-bold text-black'>Munich Lager</h4>
                                <p className='text-black'>An easy drinking beer inspired by its availability in Munich. A gold-colored German lager with a smooth, malty... </p>
                            </div>
                        </div>
                  </div>

                  <div className='slider-product'>
                        <div className='product-carousel-item'>
                            <div className='product-carousel-brand'>
                            <img src={glass_05} alt='glass' className='glass-responsive'/>
                            </div>
                            <div className='product-carousel-details'>
                                <h4 className='fw-bold text-black'>Doppelbock</h4>
                                <p className='text-black'>It’s a double strength lager to put it plainly. A strong, rich, and very malty German lager that can have both pale... </p>
                            </div>
                        </div>
                  </div>


                  <div className='slider-product'>
                        <div className='product-carousel-item'>
                            <div className='product-carousel-brand'>
                            <img src={glass_01} alt='glass' className='glass-responsive'/>
                            </div>
                            <div className='product-carousel-details'>
                                <h4 className='fw-bold text-black'>Belgian Golden Strong</h4>
                                <p className='text-black'>A golden ale which is crushable yet deceivingly boozy. It’s at 8% ABV and quite flavourful. It is smooth with alcoh... </p>
                            </div>
                        </div>
                  </div>

                  <div className='slider-product'>
                        <div className='product-carousel-item'>
                            <div className='product-carousel-brand'>
                            <img src={glass_05} alt='glass' className='glass-responsive'/>
                            </div>
                            <div className='product-carousel-details'>
                                <h4 className='fw-bold text-black'>American Amber ale </h4>
                                <p className='text-black'>An amber, hoppy, moderate-strength American craft beer with a malty caramel flavor. The balanc... </p>
                            </div>
                        </div>
                  </div>

                  <div className='slider-product'>
                        <div className='product-carousel-item'>
                            <div className='product-carousel-brand'>
                                <img src={glass_05} alt='glass' className='glass-responsive'/>
                            </div>
                            <div className='product-carousel-details'>
                                <h4 className='fw-bold text-black'>Cider </h4>
                                <p className='text-black'>A beverage which is not beer but got adoption to the craft beer trend in India. It’s... </p>
                            </div>
                        </div>
                  </div>
                </Slider>   
            </div>
            <div className="div-block-69 product-block-beers">
                <div className="product__flavors__fixed__scroll__layout">
                    <div id="home_color-black" className="flavor__slide is--first">
                        <div className="facts__wrapper">
                            <div className="facts__text">
                            <h3 className="h3 text-align-left black is--scroll--products _plines">
                                <b className='_plines'>100+</b><br/>Unique Beers
                            </h3>
                            <p className="p-text">Discover Our Passion for Flavor!</p>
                                <a href="/pints-products"
                                    className="link-block w-inline-block">
                                    <div className="inner-btn">
                                        <div className="text-block">Explore a world of flavor!</div>
                                        <div className="right-arrow-wrapper is--relative">
                                            <div className="right-arrow-svg w-embed"><svg
                                                     width="inherit"
                                                    height="inherit" viewBox="0 0 20 20"
                                                    xmlns="http://www.w3.org/2000/svg" fill="none">
                                                    <path fill-rule="evenodd" clip-rule="evenodd"
                                                        d="M12.6068 4.2343C12.2163 3.84378 11.5831 3.84378 11.1926 4.2343C10.8021 4.62482 10.8021 5.25799 11.1926 5.64851L14.5443 9.00022H4.16797C3.61568 9.00022 3.16797 9.44794 3.16797 10.0002C3.16797 10.5525 3.61568 11.0002 4.16797 11.0002H14.5451L11.1926 14.3527C10.8021 14.7433 10.8021 15.3764 11.1926 15.767C11.5831 16.1575 12.2163 16.1575 12.6068 15.767L17.666 10.7077C18.0566 10.3172 18.0566 9.68405 17.666 9.29352L12.6068 4.2343Z"
                                                        fill="#000" fill-opacity="0.88"></path>
                                                </svg></div>
                                        </div>
                                    </div>
                                </a>
                            </div>
                          
                        </div>

                        <div className="flavor__background"></div>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <div className="section-home-scroll">
       {/* <div id="Products-Mobile" className="products__flavors__text__wrapper section-home-products-m is--mobile">
            <div className="products__flavor__text__position">
                <div className="products__flavors__text__layout-2">
                    <h2  className="section-heading text-align-center">Crafted with passion.Brewed with precision.</h2>
                </div>
            </div>
        </div> */}
        <section className="reviews">
            <div className="review__wrapper-2">
                <div className="review__container-2">
                    <div className="padding__vertical is--padding--xxhuge">
                        <div className="review__content-2">

                            <div className="review__title-2 review_intro products">
                                <div className="review__intro">
                                    <div className="heading-wrapper is--reviews is--desktop">
                                        <h2 className="h2 text-align-left">
                                        From new installations to expert brewing, we ensure high-quality beer and maximized output.

                                        </h2>
                                        <h2 className="h2 text-align-left">
                                        Our experts audit your brewery, identify challenges, and optimize operations for peak performance and quality.

                                        </h2>
                                        <h2 className="h2 text-align-left">
                                        Let us handle brewing while you enjoy peace of mind and a thriving, future-ready brewery.
                                        </h2>
                                    </div>

                                    <div className="heading-wrapper is--reviews is--mobile">
                                    <h2 className="h2 text-align-left">
                                        From new installations to expert brewing, we ensure high-quality beer and maximized output.

                                        </h2>
                                        <h2 className="h2 text-align-left">
                                        Our experts audit your brewery, identify challenges, and optimize operations for peak performance and quality.

                                        </h2>
                                        <h2 className="h2 text-align-left">
                                        Let us handle brewing while you enjoy peace of mind and a thriving, future-ready brewery.
                                        </h2>
                                    </div>
                                    <div className="max__width__medium"></div>
                                </div>
                            </div>
                            <div className="review__list">
                                <div 
                                    className="review__list__item-2">
                                    
                                    <div className="review__icon">
                                                <img src={icon_01} alt="icons"/>
                                            </div>

                                    <div className="review__card-2">
                                           
                                        <div className="scroll-content">
                                            <h3 className="h3 text-align-left">Expertise</h3>
                                            <p className="p-text white top-margin is--home">Our seasoned team delivers
                                             exceptional brewing solutions.
                                            </p>
                                        </div>
                                    </div>
                                </div>
                                <div className="review__list__item-2">
                                           <div className="review__icon">
                                                <img src={icon_02} alt="icons"/>
                                            </div>
                                    <div className="review__card-2">
                                        <div className="scroll-content">
                                            <h3 className="h3 text-align-left">Installations</h3>
                                            <p className="p-text white top-margin is--home">Design, installation, and turnkey solutions for breweries of all sizes.</p>
                                        </div>
                                    </div>
                                </div>
                                <div className="review__list__item-2">
                                           <div className="review__icon">
                                                <img src={icon_03} alt="icons"/>
                                            </div>
                                    <div 
                                        className="review__card-2">
                                        <div className="scroll-content">
                                            <h3 className="h3 text-align-left">Customization</h3>
                                            <p className="p-text white top-margin is--home">Tailored strategies to fit your
                                            unique brewery needs</p>
                                        </div>
                                    </div>
                                </div>
                                <div className="review__list__item-2">
                                <div className="review__icon">
                                                <img src={icon_04} alt="icons"/>
                                            </div>
                                    <div className="review__card-2">
                                        <div className="scroll-content">
                                            <h3 className="h3 text-align-left">Support</h3>
                                            <p className="p-text white top-margin is--home">
                                            Comprehensive assistance, including excise management
                                            </p>
                                        </div>
                                    </div>
                                </div>
                                <div className="review__list__item-2">
                                <div className="review__icon">
                                                <img src={icon_05} alt="icons"/>
                                            </div>
                                    <div className="review__card-2">
                                        <div className="scroll-content">
                                            <h3 className="h3 text-align-left">Result</h3>
                                            <p className="p-text white top-margin is--home">
                                            Measurable outcomes that drive your business forward
                                            </p>
                                        </div>
                                    </div>
                                </div>
                                <div className="review__list__item-2">
                                <div className="review__icon">
                                                <img src={icon_06} alt="icons"/>
                                            </div>
                                    <div className="review__card-2">
                                        <div className="scroll-content">
                                            <h3 className="h3 text-align-left">Collaboration</h3>
                                            <p className="p-text white top-margin is--home">
                                            Access to a network of top breweries
                                            </p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
           
            <div className="sticky-about-banner-2">
                <div className="background-wrapper sticky">
                    <div className="background-image-2">
                    <video className="image-full is--laptop" sizes="(max-width: 479px) 100vw, 98vw" autoPlay loop muted>
    <source src={pintsbgvideos} type='video/mp4' />
</video>
                        {/* <img src="https://cdn.prod.website-files.com/63f9558eecdaabcd7d449b81/63f9558eecdaabfd73449cd6_Untitled%20design%20-%202023-02-23T164313.075.webp"
                            loading="lazy" width="1280" sizes="(max-width: 479px) 100vw, 98vw" alt="" className="image-full is--laptop"/> */}
                        <div className="overlay-2 dark-overlay"></div>
                    </div>
                </div>
            </div>
             
        </section>
    </div>

    

   


    <div className="section-home-images">
        <div className="padding-custom is--home--images">
            <div className="content-container is--home--images">
                <h2 className="section-heading text-align-center white">
                From grain to glass<br/>we've got you covered

                    </h2>
                <div className="paragraph-wrapper">
                    <p className="p-text top-margin text-align-center white">
                    Over a decade in brewing excellence combined with our expert team ensures your craft beer vision becomes a resounding success.

                    </p>
                </div><a href="/about-pints" className="link-block center white is--bout w-inline-block">
                    <div className="inner-btn">
                        <div className="text-block black">Learn More</div>
                        <div className="right-arrow-wrapper is--relative is--blue">
                            <div className="right-arrow-svg w-embed"><svg 
                                    width="inherit" height="inherit" viewBox="0 0 20 20"
                                    xmlns="http://www.w3.org/2000/svg" fill="none">
                                    <path fill-rule="evenodd" clip-rule="evenodd"
                                        d="M12.6068 4.2343C12.2163 3.84378 11.5831 3.84378 11.1926 4.2343C10.8021 4.62482 10.8021 5.25799 11.1926 5.64851L14.5443 9.00022H4.16797C3.61568 9.00022 3.16797 9.44794 3.16797 10.0002C3.16797 10.5525 3.61568 11.0002 4.16797 11.0002H14.5451L11.1926 14.3527C10.8021 14.7433 10.8021 15.3764 11.1926 15.767C11.5831 16.1575 12.2163 16.1575 12.6068 15.767L17.666 10.7077C18.0566 10.3172 18.0566 9.68405 17.666 9.29352L12.6068 4.2343Z"
                                        fill="#fff" fill-opacity="0.88"></path>
                                </svg></div>
                        </div>
                    </div>
                </a>
            </div>
            <div className="content-container is--home--images is--2">
                <div className="img-wrapper is--home--images _1"></div>
                {/* <div className="img-wrapper is--home--images _3">
                </div>
                <div className="img-wrapper is--home--images _2"></div> */}
            </div>
        </div>
    </div>

    <div className="section-home-products is--clients">
        <div className="products__flavors__text__wrapper">
            <h3 className="section-heading">
            Experience on our<br/>
                <b>shoulders</b>
            </h3>
          </div>

            <div className='slider-container'>
                <div className='brand-mt20'>
                <Slider {...experience}>
                  <div><img className="d-block-w-100" src={experience_01} alt="First slide"/></div>
                  <div><img className="d-block-w-100" src={experience_02} alt="Second slide"/></div>
                  <div><img className="d-block-w-100" src={experience_03} alt="Second slide"/></div>
                  <div><img className="d-block-w-100" src={experience_04} alt="Second slide"/></div>
                  <div><img className="d-block-w-100" src={experience_05} alt="Second slide"/></div>
                  <div><img className="d-block-w-100" src={experience_06} alt="Second slide"/></div>
                  <div><img className="d-block-w-100" src={experience_07} alt="Second slide"/></div>
               </Slider>
                </div>
            </div>
</div>   

    <div className="section-home-info">
        <div  className="padding-custom is--home--info">
            <div className="content-container is--home--info is--2">
                <div className="content-container is--home--info">
                    <div className="quote_svg w-embed"><svg xmlns="http://www.w3.org/2000/svg" data-name="Layer 1"
                            viewBox="0 0 32 32">
                            <path fill="#fff"
                                d="M24 15a7 7 0 0 0-1 .08 9 9 0 0 1 4.59-7.33c.85-.48 1.81-1.23 1.25-2.5a1.88 1.88 0 0 0-2.54-1.12l-.21.08C20.65 6.24 16 12 17 22c.37 4 3.13 7 7 7a7 7 0 0 0 0-14zM8 15a7 7 0 0 0-1 .08 9 9 0 0 1 4.59-7.33c.85-.48 1.81-1.23 1.25-2.5a1.88 1.88 0 0 0-2.54-1.12l-.21.08C4.65 6.24 0 12 1 22c.37 4 3.13 7 7 7a7 7 0 1 0 0-14z">
                            </path>
                        </svg></div>
                    <h2 className="section-heading text-align-left section-scroll-anime">
                    Expert guidance,tailored solutions & exceptional beer.

                    </h2>
                    <h2 className="section-heading text-align-left section-scroll-anime">
                    Ensuring a profitable & sustainable business growth.
                    </h2>
                </div>
                
                <div className="home-info-img-wrapper is--03">
                    <div className="bg-cream"></div>
                </div>
                <div className="home-info-img-wrapper is--02">
                    <div className="bg-cream"></div>
                </div>
                <div className="home-info-img-wrapper is--01">
                    <div className="bg-cream"></div>
                </div>
            </div>
            
        </div>
    </div>

    
     <Contactform/>
    <Footer/>
 
</div>
        </section>
    )
}

export default Home;